import { FileAttachment, Task } from "../../../../models"
import { TasksResults } from "./getFeedTasks"
import { Dispatch } from "redux"
import { addTasksAction } from './addTasksAction'
import { CheckListToTasks } from "../tasksReducer"

export interface TaskResponse {
    key: string,
    created: string,
    isDone: boolean,
    text: string,
    docId: string,
    checklistUid: string
    startDate?: string
    files?: FileAttachment[]
    endDate?: string
}

export interface TasksResponse {
    tasks: TaskResponse[],
    total: number
}

export const processTasksResponse = (dispatch: Dispatch) => (tasksResponse: TasksResponse): TasksResults => {
    const tasks: Task[] = tasksResponse.tasks.map((taskResponse: TaskResponse) => {
        const task = processSingleTaskResponse(taskResponse)

        return task;
    })

    dispatch(addTasksAction(tasks))

    return {
        tasks,
        total: tasksResponse.total
    };
}

export const processSingleTaskResponse = (taskResponse: TaskResponse): Task => {
    const task: Task = {
        taskId: taskResponse.key,
        docId: taskResponse.docId,
        created: taskResponse.created,
        isDone: taskResponse.isDone,
        text: taskResponse.text,
        checklistUid: taskResponse.checklistUid,
        attachments: taskResponse?.files ?? [],
        startDate: taskResponse.startDate,
        endDate: taskResponse.endDate
    }

    return task
}